import { CustomerModel } from './customer';
import { PropertyModel } from './property';
import { PropertyUnitModel } from './property-unit';
import { CompanyModel } from './company';

export enum ReservationTagType {
  UNKNOWN,
  ARRIVED,
  NOT_ARRIVED,
  PAID,
  UNPAID,
  OVERPAID
}

export enum ReservationStatus {
  CANCELED,
  CONFIRMED,
  ENQUIRED,
  OPTIONAL,
  PROCESSED,
  REQUESTED,
  STARTED
}

export interface ReservationTagModel {
  readonly id: string;
  readonly type: ReservationTagType;
  readonly label: string;
}

export interface ReservationNoteModel {
  readonly id: string;
  readonly text: string;
}

export interface ReservationModel {
  readonly id: string;
  readonly confirmationNumber: string;
  readonly channelConfirmationNumber?: string;
  readonly startDate: Date;
  readonly endDate: Date;
  readonly status: ReservationStatus;
  readonly checkInDate: Date | null;
  readonly source: string | null;
  readonly slug: string;

  // extends
  readonly customer?: CustomerModel;
  readonly property?: PropertyModel;
  readonly propertyUnit?: PropertyUnitModel;
  readonly reservationNotes?: ReservationNoteModel[];
  readonly reservationTags?: ReservationTagModel[];
  readonly company?: CompanyModel;
}
